import { useCallback, useState, type ReactNode } from 'react'
import { FrameContext, lastFamily, remember, type Page } from '@/lib/frame'

export function FrameProvider({ children }: { children: ReactNode }) {
  const [familyId, setFamily] = useState<string | null>(lastFamily)
  const [page, setPage] = useState<Page>({})
  const [actionSlot, setActionSlot] = useState<HTMLElement | null>(null)
  const [rowSlot, setRowSlot] = useState<HTMLElement | null>(null)
  const setFamilyId = useCallback((id: string | null) => {
    remember(id)
    setFamily(id)
  }, [])
  return (
    <FrameContext.Provider
      value={{
        familyId,
        setFamilyId,
        page,
        setPage,
        actionSlot,
        setActionSlot,
        rowSlot,
        setRowSlot,
      }}
    >
      {children}
    </FrameContext.Provider>
  )
}
